import { POST_APPLICANT_SCOPE, SATISFACTION_SURVEY_SCOPE, QUESTIONNAIRE_TYPE_LIST } from '@/constant/questionnaire'

export const questionnaireMixin = {
  data () {
    return {
      logoUrl: '',
      languageOptions: [{ id: 'zh', text: '简体中文' }, { id: 'en', text: 'English' }, { id: 'hk', text: '繁體中文' }],
      fixStyle: '',
      messages: []
    }
  },
  computed: {
    invitationId () {
      return this.$route.params.invitationId
    },
    isRequiredMessage () {
      return (this.isRequired === 'true' || this.isRequired === true) ? this.$t('questionnaire.error.isRequired') : this.isRequired
    }
  },
  created () {
    this.logoUrl = this.$parent.logoPath
  },
  mounted () {},
  methods: {
    toVuePage (path, openNewWindow) {
      if (openNewWindow) {
        const newPath = this.$router.resolve(path)
        window.open(newPath.href, '_blank')
      } else {
        this.$router.push(path)
      }
    },
    toOutSide (path, openInCurrentWindow) {
      if (openInCurrentWindow) {
        window.location.href = path
      } else {
        window.open(path, '_blank')
      }
    },
    fieldIsRequired (value) {
      return value !== false && value !== 'false'
    },
    getText (text) {
      let key = this.$i18n.locale
      if (key === 'hk') {
        key = 'tc'
      }
      if (key === 'zh') {
        key = 'cn'
      }
      if (text && text[key]) {
        return text[key]
      }
      return ''
    },
    getOptions (options) {
      const result = []
      const getText = this.getText
      for (const option of options) {
        if (option) {
          result.push({
            id: option.id,
            get text () {
              return getText(option.text)
            }
          })
        }
      }
      return result
    },
    sortSteps (steps) {
      if (!(steps instanceof Array)) {
        return
      }
      return steps.sort((a, b) => { return a.order < b.order ? -1 : 1 })
    },
    addFileModelForInput (stepQuestionList) {
      for (let index = 0; index < stepQuestionList; index++) {
        const question = stepQuestionList[index]
        if (question.type === 'ATTACHMENT') {
          stepQuestionList[index].file = ''
          stepQuestionList[index].uploadFunc = ''
        }
      }
      return stepQuestionList
    },
    showMessage (text, type, delay = 3) {
      this.messages.push({
        text: text,
        type: type,
        delay: delay
      })
    },
    getQuestionnaireLabelByType (type) {
      if (!QUESTIONNAIRE_TYPE_LIST.includes(type)) {
        if (this.$i18n.locale === 'zh') {
          return '调查问卷'
        } else if (this.$i18n.locale === 'hk' || this.$i18n.locale === 'tw') {
          return '調查問卷'
        } else {
          return 'Questionnaire'
        }
      }
      if (type === POST_APPLICANT_SCOPE) {
        if (this.$i18n.locale === 'zh') {
          return '调查问卷'
        } else if (this.$i18n.locale === 'hk' || this.$i18n.locale === 'tw') {
          return '調查問卷'
        } else {
          return 'Questionnaire'
        }
      } else if (type === SATISFACTION_SURVEY_SCOPE) {
        if (this.$i18n.locale === 'zh') {
          return '满意度调查问卷'
        } else if (this.$i18n.locale === 'hk' || this.$i18n.locale === 'tw') {
          return '滿意度調查問卷'
        } else {
          return 'Satisfaction Survey'
        }
      } else {
        if (this.$i18n.locale === 'zh') {
          return '调查问卷'
        } else if (this.$i18n.locale === 'hk' || this.$i18n.locale === 'tw') {
          return '調查問卷'
        } else {
          return 'Questionnaire'
        }
      }
    }
  }
}
